import { DateField, TextField } from "react-admin";

import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { "value-converter": highlightedValueConverterIds = [] } =
    useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedValueConverterIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      perPage={10}
      split
      type="table"
      filters={<Filters />}
      key={highlightedValueConverterIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="value-converter"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="code" variant="body2" />
        <TextField source="name" />
        <DateField source="modified" showTime />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
